import type { ConsentChoice } from "@/5-shared/types";

export type { ConsentChoice };

import { setAnalyticsConsent } from "../metrics";
import { CONSENT_KEY } from "./key";

export { CONSENT_KEY };

export function getStoredConsent(): ConsentChoice | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(CONSENT_KEY);
    if (raw === "granted" || raw === "denied") return raw;
    return null;
  } catch {
    return null;
  }
}

export function setStoredConsent(v: ConsentChoice) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(CONSENT_KEY, v);
  } catch {
    /* ignore */
  }
}

export function applyAnalyticsConsent(v: ConsentChoice) {
  setStoredConsent(v);
  // Update consent only. The landing page_view already fired at hydration (as a
  // cookieless Consent Mode ping, which still counts); re-firing it here just
  // double-counted the pageview. Granting consent upgrades subsequent hits.
  // Confirmed in GA4 (Oct 2026): while v5.0.2 re-sent it, every new visitor who
  // accepted counted their landing page twice, and "(not set)" landings remained.
  setAnalyticsConsent(v === "granted");
}
